import React from 'react'
import styled from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
import { Tabs } from 'antd'
import ReviewTab from './ReviewTab'
import CertificateTab from './CertificateTab'
import LectureTab from './LectureTab'
import theme from 'theme'

const { TabPane } = Tabs
const Container = styled.div`
  width: 100%;

  @media (max-width: 720px) {
    margin-bottom: 30px;
  }
  @media (max-width: 425px) {
    margin-bottom: 20px;
  }

  .ant-tabs-tab-btn {
    min-width: 80px;
    color: ${({ theme }) => theme.gray3};
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;

    @media (max-width: 425px) {
      font-size: 14px;
    }
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #ffffff;
  }
  .ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: 1px solid ${({ theme }) => theme.gray3};
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar {
    background-color: ${({ theme }) => theme.primary1};
    height: 7px;
  }
  .ant-tabs-top > .ant-tabs-nav {
    @media (max-width: 425px) {
      margin: 0;
    }
  }
`

const TabSection = (props) => {
  const { course, certificates, lectures, locale } = props
  const { avgRating: rating, id: courseId, schoolId } = course
  const isTh = locale === 'th'
  const filteredLectures = lectures.filter((item) => item.type === '')
  const hideLectureTab = filteredLectures.length <= 0
  const hideRating = !rating || rating <= 0
  const hideCertificate = certificates.length <= 0

  const tabs = [
    {
      key: '1',
      label: isTh ? 'เลคเชอร์' : 'Lecture',
      component: <LectureTab lectures={filteredLectures} courseImage={course?.image} />,
      isHidden: hideLectureTab,
    },
    {
      key: '2',
      label: isTh ? 'รีวิว' : 'Review',
      component: <ReviewTab courseId={courseId} />,
      isHidden: hideRating,
    },
    {
      key: '3',
      label: isTh ? 'ประกาศนียบัตร' : 'Certificate',
      component: <CertificateTab certificates={certificates} schoolId={schoolId} />,
      isHidden: hideCertificate,
    },
  ]

  if (hideLectureTab && hideRating && hideCertificate) {
    return null
  }

  return (
    <ErrorBoundary>
      <Container>
        <Tabs defaultActiveKey="1">
          {tabs
            .filter((item) => !item.isHidden)
            .map((item) => {
              return (
                <TabPane
                  key={item.key}
                  tab={<div style={{ color: '#253e87' }}>{item.label}</div>}
                  style={{ fontSize: theme['text.sm'] }}
                >
                  {item.component}
                </TabPane>
              )
            })}
        </Tabs>
      </Container>
    </ErrorBoundary>
  )
}

export default TabSection
